import { SITELINK } from '../../app-routes/Links';
import TopBar from '../../layouts/~includes/TopBar';

const MySubscription = () => {
  document.body.classList.remove('overflow-hidden');
  return (
    <section className="bg-white dark:bg-neutral-800 h-[100vh]">
      {/* top lead area and post btn */}
      <div className="fixed top-0 w-full z-50">
        <TopBar title='Subscription' link={SITELINK.HOME}/>
      </div>

      <div className="mt-[40px] mb-10 md:mt-0 md:mb-0">
        <div className="relative py-3">
          <div className="text-center">
            <p className="text-xs flex flex-col mt-24">No subscription available</p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default MySubscription;
